// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_nPw","cls2":"CourseResults-cls2_hvV CourseResults-cls1_nPw"};